// extracted by mini-css-extract-plugin
module.exports = {"button":"XButton_button__1mBUq"};